import React from 'react'
import { Text, View } from 'oio-react'
import { Link } from 'react-router-dom'

const AdminWorkspacePageUpdates = () => (
   <View display="flex" justifyContent="center" width="100%">
      <View
         width="100%"
         maxWidth="100%[a-c] 660px[d-f]"
         padding="20px[a] 25px[b] 30px[c] 40px[d-f]">
         <Text size="5" lineHeight="150%" color="#222">
            Creating, Editing and Managing Pages and Content Types
         </Text>
         <br />
         <View display="flex">
            <View flex="1 1 auto" paddingRight="20px">
               <Text size="2" lineHeight="150%" color="#666">
                  {'Hey there 👋 We have moved the settings for creating, editing and managing Pages and Content Types '}
                  <Link to="/-/admin/product-updates" style={{ color: '#222' }}>
                     <u>in a recent release</u>
                  </Link>
                  {'. These settings have moved in an effort to make adding and editing your content easier and more streamlined.'}
                  <br />
                  <br />
                  <Text size="2" weight="medium" lineHeight="150%" color="#222">
                     Creating Pages
                  </Text>
                  {'In the Main Menu, look for the "plus" (+) button or "New Page" button to add a new Page.'}
                  <br />
                  <br />
                  <Text size="2" weight="medium" lineHeight="150%" color="#222">
                     Editing and Deleting Pages
                  </Text>
                  {'To edit or delete a page, look for the "three-dot" (...) button to find more page-specific settings (including the ability to edit and remove that page).'}
               </Text>
            </View>
            <View
               flex="0 0 auto"
               width="180px"
               height="180px"
               borderRadius="6px"
               backgroundSize="cover"
               backgroundPosition="center center"
               backgroundImage="url(/assets/images/helpers/page-settings-helper-3.jpg)"
            />
         </View>
         <View
            marginTop="20px"
            width="100%"
            paddingTop="50%"
            borderRadius="6px"
            backgroundSize="cover"
            backgroundPosition="center center"
            backgroundImage="url(/assets/images/helpers/page-settings-helper-4.jpg)"
         />
         <Text size="2" lineHeight="150%" color="#666">
            <br />
            <Text size="2" weight="medium" lineHeight="150%" color="#222">
               Managing Content Types
            </Text>
            {'The settings for managing your Content Types have also moved. They can now be found on the page where your Content Type resides. For example, to access Content Type settings for "Events", go to your "Events" page, click on the "three-dot" (...) button, then "Manage Content".'}
            <br />
            <br />
            {'If you are having issues or need help, please don\'t hesitate to reach out to '}
            <a href="mailto:support@mother.co">
               <u style={{ color: '#222' }}>support@mother.co</u>
            </a>
         </Text>
         <View
            marginTop="20px"
            width="100%"
            paddingTop="70%"
            borderRadius="6px"
            backgroundSize="cover"
            backgroundPosition="top center"
            backgroundImage="url(/assets/images/helpers/page-settings-helper-5.jpg)"
         />
      </View>
   </View>
)

export default AdminWorkspacePageUpdates
